module.exports = __webpack_public_path__ + "static/media/reactlogo.f1b9f2be.png";